/* eslint-disable-next-line no-restricted-imports */
import useId from '@mui/material/utils/useId';
import { ReactNode } from 'react';

interface UseFormFieldIdProps {
  idOverride?: string;
  helperText?: ReactNode;
  label?: ReactNode;
}

type ReturnValue = string | undefined;

export default function useFormFieldId({ idOverride, helperText, label }: UseFormFieldIdProps)
  : [ReturnValue, ReturnValue, ReturnValue] {
  const id = useId(idOverride);
  const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
  const inputLabelId = label && id ? `${id}-label` : undefined;

  return [id, helperTextId, inputLabelId];
}
